var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagUa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7766 14.9185C3.84985 14.9185 0.666596 11.7352 0.666596 7.80849C0.666596 3.88174 3.84985 0.698486 7.7766 0.698486C11.7033 0.698486 14.8866 3.88174 14.8866 7.80849C14.8866 11.7352 11.7033 14.9185 7.7766 14.9185Z",
    fill: "#348AF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666596 7.80841C0.666596 11.7352 3.84985 14.9184 7.7766 14.9184C11.7033 14.9184 14.8866 11.7352 14.8866 7.80841L0.666596 7.80841Z",
    fill: "#FFDB44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUa);
export default __webpack_public_path__ + "static/media/flag-ua.031f5904e5aa2bc48a9ca133e8bdaf1f.svg";
export { ForwardRef as ReactComponent };